import { Effect, all } from "redux-saga/effects"
import { Injector } from "../di/Injector"
import { watchFocusChange } from "./sagas/watchFocusChange"
import { watchVisibilityChange } from "./sagas/watchVisibilityChange"
import { watchWindowResize } from "./sagas/watchWindowResize"

export function* screen(injector: Injector): Generator<Effect> {
  yield all([watchFocusChange(injector), watchVisibilityChange(injector), watchWindowResize(injector)])
}
